<template>
  <div
    v-if="state"
    class="san-stats"
  >
    <slot
      v-bind="state"
      :results="state.instantSearchInstance.helper.lastResults"
    >
      <span class="san-stats--text">
        <template v-if="state.areHitsSorted">
          {{ t('Stats.countSorted.results', { type: 'brands', sorted: state.nbSortedHits, count: state.nbHits, time: state.processingTimeMS.toLocaleString() }) }}
        </template>
        <template v-else>
          {{ t('Stats.count.results', { type: 'brands', count: state.nbHits, time: state.processingTimeMS.toLocaleString() }) }}
        </template>
      </span>
    </slot>
  </div>
</template>

<script setup>
import { connectStats } from 'instantsearch.js/es/connectors'
import { useConnector } from '@/composables'
import { useTranslation } from 'i18next-vue'

defineOptions({ name: 'SanInfiniteHits' })

const { t } = useTranslation('instantsearch')
const state = useConnector(connectStats, {
  $$widgetType: 'ais.stats'
})

</script>
